import { Component, inject, Input } from '@angular/core';
import { DemandeContact } from '../../models/demandeContact';
import { TuiAppearance, TuiButton } from '@taiga-ui/core';
import { RouterLink } from '@angular/router';
import {
  TuiChip,
  TuiPdfViewerOptions,
  TuiPdfViewerService,
} from '@taiga-ui/kit';
import { DatePipe } from '@angular/common';
import { PolymorpheusContent } from '@taiga-ui/polymorpheus';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DemandeContactService } from '../../services/demande-contact.service';

@Component({
  selector: 'app-demande-contact-row',
  standalone: true,
  imports: [TuiAppearance, TuiChip, TuiButton, RouterLink, DatePipe],
  templateUrl: './demande-contact-row.component.html',
  styleUrl: './demande-contact-row.component.scss',
})
export class DemandeContactRowComponent {
  @Input({ required: true }) demandeContact!: DemandeContact;
  @Input() afficherPatient?: boolean = false;

  private readonly sanitizer = inject(DomSanitizer);
  private readonly pdfService = inject(TuiPdfViewerService);
  private readonly demandeContactService = inject(DemandeContactService);

  openLast(actions: PolymorpheusContent<TuiPdfViewerOptions>): void {
    this.demandeContactService.pdf(this.demandeContact.id).subscribe({
      next: (blob) => {
        // Créer une URL sécurisée
        const url: SafeResourceUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(blob),
          );
        try {
          if (this.demandeContact?.pdf) {
            this.pdfService
              .open(url, {
                label: 'Pièce jointe',
                actions,
              })
              .subscribe();
          }
        } catch (error) {
          console.error(
            "Erreur lors de l'ouverture de la dernière prescription : ",
            error,
          );
        }
      },
    });
  }
}
